
export enum SubroomNameEnum {
	None = "",

	FyrstahaedBistroFacilities = "tron",

	Onnurhaedogit = 'windows',

	Thridjahaedogcrossindustry = 'batman',


	Innova ='subway',

	Innovation = 'greenroom',

	Framleidslustyring = 'aliens',
}